import React from 'react';
import PanelLogo from '../assets/images/logo/logo.webp';

const Logo = () => {

    return (
        <img style={{ height: 44, width: 'auto' }} alt='Logo' src={PanelLogo}/>
    );
};

export default Logo;
